import { rest } from "msw";
import { apiUrl } from "features/configure";
import { websiteTraffic } from "./data/MockWebsiteTraffic";
const getTrafficObjectives = rest.get(
  `${apiUrl}/api/trackingObjective/:entityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.objectives));
  }
);

const getTrafficTrackingStats = rest.post(
  `${apiUrl}/api/dashboard/:entityName/trackingStats`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.trackingStats));
  }
);
const getTrafficWalletAnalysis = rest.post(
  `${apiUrl}/api/dashboard/:entityName/walletAnalysis`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.walletAnalysis));
  }
);
const getTrafficUserMatrix = rest.post(
  `${apiUrl}/api/dashboard/:entityName/userMatrix`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.userMatrix));
  }
);
const getTrafficCohortRetention = rest.post(
  `${apiUrl}/api/dashboard/:entityName/cohortRetention`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.cohortRetention));
  }
);
const getTrafficObjectivesBreakdown = rest.post(
  `${apiUrl}/api/dashboard/:entityName/objectivesBreakdown`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.objectivesBreakdown));
  }
);

const getTrafficReferer = rest.get(
  `${apiUrl}/api/dashboard/:entityName/referer`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.referrer));
  }
);

const getTrafficAllCharts = rest.get(
  `${apiUrl}/api/dashboard/:entityName/allCharts`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.allCharts));
  }
);
const getTrafficLineChart = rest.get(
  `${apiUrl}/api/dashboard/:entityName/lineChart`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.lineChart));
  }
);

const getTrafficObjectivesSubEntity = rest.get(
  `${apiUrl}/apiEvaluate/trackingObjective/:entityName/:subEntityName`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.objectives));
  }
);

const getTrafficTrackingStatsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/trackingStats`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.trackingStats));
  }
);
const getTrafficWalletAnalysisSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/walletAnalysis`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.walletAnalysis));
  }
);
const getTrafficUserMatrixSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/userMatrix`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.userMatrix));
  }
);
const getTrafficCohortRetentionSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/cohortRetention`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.cohortRetention));
  }
);
const getTrafficObjectivesBreakdownSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/objectivesBreakdown`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.objectivesBreakdown));
  }
);

const getTrafficRefererSubEntity = rest.get(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/referer`,
  (req, res, ctx) => {
    console.log("websiteTraffic.referrer: ", websiteTraffic.referrer);
    return res(ctx.status(200), ctx.json(websiteTraffic.referrer));
  }
);

const getTrafficAllChartsSubEntity = rest.get(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/allCharts`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.allCharts));
  }
);
const getTrafficLineChartSubEntity = rest.get(
  `${apiUrl}/apiEvaluate/dashboard/:entityName/:subEntityName/lineChart`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(websiteTraffic.lineChart));
  }
);

export const websiteTrafficMocks = [
  getTrafficObjectives,
  getTrafficWalletAnalysis,
  getTrafficReferer,
  getTrafficAllCharts,
  getTrafficLineChart,
  getTrafficTrackingStats,
  getTrafficObjectivesBreakdown,
  getTrafficCohortRetention,
  getTrafficUserMatrix,

  getTrafficObjectivesSubEntity,
  getTrafficTrackingStatsSubEntity,
  getTrafficWalletAnalysisSubEntity,
  getTrafficUserMatrixSubEntity,
  getTrafficCohortRetentionSubEntity,
  getTrafficObjectivesBreakdownSubEntity,
  getTrafficRefererSubEntity,
  getTrafficAllChartsSubEntity,
  getTrafficLineChartSubEntity,
];
